import { ConnectButton } from 'components/ConnectButton';
import { Normal4, Title2, Title5 } from 'components/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useClientRenderDelay } from 'utils/hooks/useClientRenderDelay';
import { useConnection } from 'wagmi';
import { useRouter } from 'next/navigation';
import dynamic from 'next/dynamic';

const TestnetAnimation = dynamic(() => import('./TestnetAnimation'), {
  ssr: false,
});

export const TestNetHeader: React.FC = () => {
  const { t } = useTranslation('testnet');
  const { isConnected } = useConnection();
  const csr = useClientRenderDelay();
  const isWalletConnected = csr && isConnected;
  const router = useRouter();
  return (
    <>
      <div
        className={`min:h-4/5 relative z-10 mx-auto flex h-max w-full  flex-col-reverse items-start justify-start gap-2 pb-8 lg:h-full lg:flex-row lg:items-center lg:gap-0 lg:pb-40 lg:pt-28 2xl:w-full 2xl:max-w-[120rem]`}
      >
        <div className='mx-auto flex w-full max-w-[100rem] flex-col gap-4 pl-4 pt-4 max-lg:px-5 lg:pb-6 lg:pl-16 lg:pr-8'>
          <div className=' z-10 flex grid-cols-2 flex-col items-center justify-start gap-4 max-lg:px-0 md:max-w-[500px] lg:gap-6 xl:max-w-full xl:p-4 xl:px-8'>
            <Normal4 className='me-auto w-full max-w-[500px] text-start font-normal lg:text-[2.75rem] lg:leading-[50px]'>
              {t('SFI_TESTNET')}{' '}
              <Normal4 className='font-normal text-negative-800'>
                {t('HAS_NOW_END')}
              </Normal4>
            </Normal4>
            <div className='flex w-full flex-row gap-[10px]'>
              {!isWalletConnected && (
                <ConnectButton
                  label={t('CONNECT_WALLET')}
                  className='px-3 text-xs font-bold text-black-1000 xs:rounded-full md:px-8 md:py-3 lg:text-lg'
                />
              )}
              <button
                onClick={() => router.push('/testnet/claim')}
                className='rounded-full border-[0.4px] border-mono-100 bg-[linear-gradient(102.69deg,_#151518_0%,_#0E0E13_100%)] px-3 hover:border-[0.2px] hover:bg-[linear-gradient(103deg,_#363636_0%,_#1A1A1A_100%)] md:px-8 md:py-3'
              >
                <Title2 className='text-xs font-bold text-white lg:text-lg'>
                  {t('CLAIM_REWARDS')}
                </Title2>
              </button>
            </div>
            <Title5 className='w-full font-medium'>
              {t('THANKS_FOR_PARTICIPATING')}
            </Title5>
          </div>
        </div>
        <TestnetAnimation />
      </div>
    </>
  );
};
